import { DEFAULT_KEY_CONNECTOR } from './bridging_constants';

export const prepareBridgingParams = (payload) => {
    let params = `snapshot=${payload.snapshotId}`

    if (payload.marketplace.trim().length > 0) {
        params = `${params}&marketplaceIdsCsv=${payload.marketplace}`
    }

    if (payload.timeFrame.trim().length > 0) {
        params = `${params}&timeFramesCsv=${payload.timeFrame}`
    }

    if (!payload.productLines.includes("All") && payload.productLines.trim().length > 0) {
        params = `${params}&productLineIdsCsv=${payload.productLines}`
    }

    if (payload.currency.trim().length > 0) {
        params = `${params}&currency=${payload.currency}`
    }

    if (payload.hasOwnProperty('groupByProductLine')) {
        params = `${params}&groupByProductLine=${payload.groupByProductLine}`
    }

    if (payload.hasOwnProperty('groupByMarketplaceId')) {
        params = `${params}&groupByMarketplaceId=${payload.groupByMarketplaceId}`
    }

    if (payload.bridgingFactor && payload.bridgingFactor.trim().length > 0) {
        params = `${params}&bridgingFactor=${payload.bridgingFactor}`
    }

    if (payload.hasOwnProperty('betaFactorsCsv')) {
        params = `${params}&betaFactorsCsv=${payload.betaFactorsCsv}`
    }

    return params;
}

export const generateKey = (keys = [], connector = DEFAULT_KEY_CONNECTOR) => {
    return keys.join(connector);
}

export const extractShipMonth = (key, connector = DEFAULT_KEY_CONNECTOR) => {
    return key.split(connector)[0];
}

export const extractMarketplaceId = (key, connector = DEFAULT_KEY_CONNECTOR) => {
    return key.split(connector)[1]
}

export const extractComponent = (key, connector = DEFAULT_KEY_CONNECTOR) => {
    let splitted = key.split(connector);
    return splitted[splitted.length - 1];
}

export const parsePercentage = (num, digit = 2) => {
    return Number.parseFloat(num).toFixed(digit);
}

export const extractBridgingFactor = ({key, keySeparator = ' ', keySuffixSeparator = '-'}) => {
    const keyParts = key.split(keySeparator)
    const keySuffix = keyParts[keyParts.length - 1]
    const keySuffixParts = keySuffix.split(keySuffixSeparator)
    
    return keySuffixParts[keySuffixParts.length - 1]
}


// WEBPACK FOOTER //
// ./src/components/reports/bridging/bridging_utils.jsx